var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0586 18.875H14.8919V11.8438C14.8919 10.741 13.6545 9.81854 12.5518 9.81854C11.4491 9.81854 10.7253 10.741 10.7253 11.8438V18.875H6.5586V6.375H10.7253V8.45833C11.4152 7.34226 13.1799 6.62216 14.3971 6.62216C16.9716 6.62216 19.0586 8.74854 19.0586 11.3229V18.875ZM4.47526 18.875H0.308594V6.375H4.47526V18.875ZM2.39194 0.125C3.54253 0.125 4.47527 1.05774 4.47527 2.20833C4.47527 3.35893 3.54253 4.29167 2.39194 4.29167C1.24134 4.29167 0.308604 3.35893 0.308604 2.20833C0.308604 1.05774 1.24134 0.125 2.39194 0.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a682b5389f5d790b848021c33b3dea46.svg";
export { ForwardRef as ReactComponent };